import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Grade = () => {
    const [gradeData, setGradeData] = useState([]);
    const [loading, setLoading] = useState(true);
  
    const getGrade = () => {
      axios.post(API_URL.GRADE_LIST, { is_seller: [0, 1] }).then(
        (res) => {
          if (res.data.status === 1) {
            setGradeData(res.data.data);
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,
            position: "top-right",
          });
        }
      );
    };
  
    const deleteCategory = (row) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this - " + row.name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          axios.post(API_URL.GRADE_DELETE, { id: row.id }).then(
            (res) => {
              if (res.data.status === 1) {
                let newData = gradeData.filter((r) => r.id != row.id);
                setGradeData(newData);
              }
              toast.success(row.name + " Delete Successfully", {
                autoClose: 3000,
                position: "top-right",
              });
              setLoading(false);
            },
            (error) => {
              setLoading(false);
              toast.error("Something went wrong..", {
                autoClose: 3000,
                position: "top-right",
              });
            }
          );
        }
      });
    };
  
    useEffect(() => {
        getGrade();
    }, []);
  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
        <div className="d-flex">
          <h5 className="me-1">Grade</h5>
          <small className="me-2">({gradeData.length})</small>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/grade/add"} className="btn btn-primary btn-sm">
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Add Grade
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
               {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th className="text-center" style={{width: '200px'}}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gradeData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{width: '10px'}}>{key + 1}</td>
                            <td>
                              <h2 className="table-avatar">{row.name}</h2>
                            </td>
                            <td  className="d-flex justify-content-center gap-2"
                              style={{width: '200px'}}>
                              <Link
                                to={"/admin/grade/edit/" + row.id}
                                className="btn btn-sm btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteCategory(row)}
                                className="btn btn-sm btn-danger me-2"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Grade;
